export default __webpack_public_path__ + "static/media/zoom-plus.b4f42d51.svg";